// This composable is now a simple wrapper around the plugin-provided $api
// It's kept for backward compatibility with existing code
export const useApi = (request, opts = {}) => {
  const { $api } = useNuxtApp()

  return $api(request, opts)
}
